
<div>
  <nav
    v-if="isReady"
    class="o-grid -xs-middle -xs-right -xs-gutter-medium"
  >
    <span
      v-for="(department, index) in departments"
      :key="department.slug"
      class="o-grid__item -xs-shrink t-xs-hide t-lg-inline-block"
      @mouseenter="toggleNavigationPanel(index)"
      @mouseleave="toggleNavigationPanel(null)"
    >
      <a
        class="c-header__link"
        :class="{ 'is-active': index === openedPanelIndex }"
        :href="departmentLink(department)"
        :data-navigation-panel-trigger="`${department.slug}-panel`"
        :data-testid="`button-bar-category-${department.slug}`"
        @click="registerInteraction(`department_${department.slug}`)"
      >
        {{ department.title }}
      </a>
    </span>

    <span class="o-grid__item -xs-shrink t-xs-hide t-lg-inline-block">
      <a
        class="c-header__link"
        href="/enjoei-pro"
        data-testid="button-bar-category-enjoei-pro"
        @click="registerInteraction('department_pro')"
      >
        Enjoei pro
      </a>
    </span>

    <span class="o-grid__item -xs-shrink t-xs-hide t-lg-inline-block l-separator-wrapper">
      <span class="c-header__separator" />
    </span>

    <span
      class="o-grid__item -xs-shrink"
      :class="{
        't-xs-hide t-lg-inline-block': user.isSignedIn
      }"
    >
      <a
        href="/ajuda"
        aria-label="ir para ajuda"
        rel="nofollow"
        data-testid="button-bar-help"
        @click="registerInteraction('help')"
      >
        <vIcon
          name="help"
          color="extra-dark"
          title="ajuda"
          :custom-classes="['t-xs-hide t-lg-inline-block']"
        />

        <span class="c-header__link t-lg-hide">
          Ajuda
        </span>
      </a>
    </span>

    <span
      v-if="isMegaphoneEnabled"
      class="o-grid__item -xs-shrink"
      :class="{
        't-xs-hide': !user.isSignedIn
      }"
    >
      <a
        :href="user.profilePath"
        aria-label="ir para minha lojinha"
        data-testid="button-bar-megaphone"
        @click="registerInteraction('megaphone')"
      >
        <span
          class="c-header__megaphone-wrapper"
          :class="[{ 'has-flash': hasMegaphoneFlashMessage }]"
        >
          <vIcon
            name="megaphone"
            color="extra-dark"
            :custom-classes="['t-xs-hide t-lg-inline-block']"
            title="megafone"
          />
        </span>
      </a>
    </span>

    <template v-if="user.isSignedIn">
      <span class="o-grid__item -xs-shrink t-xs-hide t-lg-inline-block">
        <a
          class="t-relative"
          href="/perfil/mensagens"
          aria-label="ir para minhas mensagens"
          data-testid="button-bar-inbox"
          @click="registerInteraction('inbox')"
        >
          <vIcon
            name="inbox"
            color="extra-dark"
            title="mensagens"
          />

          <InboxNotification />
        </a>
      </span>

      <span class="o-grid__item -xs-shrink t-xs-hide t-lg-inline-block">
        <a
          class="t-relative"
          href="/meu-enjoei/continue-comprando"
          aria-label="ir para continue comprando"
          data-testid="button-bar-pending-carts"
          @click="registerInteraction('pending_carts')"
        >
          <vIcon
            name="bag"
            color="extra-dark"
            title="continue comprando"
            :custom-classes="['t-xs-hide t-lg-inline-block']"
          />

          <span
            class="c-header__notification-mark -large"
            :class="{ 'is-hidden': !user.pendingCartsCount }"
          />

          <span class="c-header__link t-lg-hide">
            Continue comprando
          </span>
        </a>
      </span>
    </template>

    <span
      class="o-grid__item -xs-shrink -lg-last l-sell-button"
      :class="{
        't-xs-hide t-lg-inline-block': !user.isSignedIn
      }"
    >
      <span class="t-relative">
        <span class="t-lg-hide">
          <a
            class="c-header__link"
            href="/quero-vender"
            data-testid="button-bar-sell"
            @click="onSellClick"
          >
            Vender
          </a>
        </span>

        <span class="t-xs-hide t-lg-block">
          <a
            class="c-header__button o-button -xs-flat -xs-large -xs-primary"
            href="/quero-vender"
            data-testid="button-bar-sell"
            rel="nofollow"
            @click="onSellClick"
          >
            Quero vender
          </a>
        </span>
      </span>
    </span>

    <div
      v-if="user.isSignedIn"
      class="o-grid__item -xs-shrink"
    >
      <span class="t-relative">
        <span
          class="t-cursor-pointer t-xs-inline-block"
          data-testid="button-bar-avatar"
          @mouseenter="isLargeDesktop ? toggleUserMenu(true) : null"
          @mouseleave="scheduleUserMenuHide"
          @click="toggleUserMenu(true)"
        >
          <img
            class="o-avatar -rounded -small js-header-avatar-preview"
            :src="user.avatarUrl"
            alt=""
          >
        </span>

        <span
          class="c-header__notification-mark -large"
          :class="{ 'is-hidden': !(salesNotificationsSum || (isMobile && user.pendingCartsCount)) }"
        />

        <vHeaderMenu
          :should-show-menu="shouldShowUserMenu"
          :should-schedule-menu-hide="shouldScheduleUserMenuHide"
          @close-menu="toggleUserMenu(false)"
        >
          <vUserMenu
            :user="user"
            :is-megaphone-enabled="isMegaphoneEnabled"
            :inbox-background-tab-notification-interval="inboxBackgroundTabNotificationInterval"
          />
        </vHeaderMenu>
      </span>
    </div>

    <span
      v-else
      class="o-grid__item -xs-shrink"
    >
      <a
        class="c-header__link"
        href="/usuario/identifique-se"
        data-testid="button-bar-login"
        rel="nofollow"
        @click="registerInteraction('login')"
      >
        Entrar
      </a>
    </span>
  </nav>
</div>
